<template>
    <div class=''>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import cnt from '@/api/cnt'
export default {
    name: 'home',
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        // 这里存放数据
        return {
            // 2023050001
            sn: ''
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.sn = this.$route.query.sn ? this.$route.query.sn : ''
        this.getUserEvent(1, 1)
        this.getConfig()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
    // 方法集合
    methods: {
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        getTravelRecord() {
            let params = {
                authType: 1,
                username: this.sn
            }
            cnt.getLogin(res => {
                if (res.code == 200) {
                    sessionStorage.setItem('activityInfo', JSON.stringify(res.data.activityInfo))
                    sessionStorage.setItem('giftCardInfo', JSON.stringify(res.data.giftCardInfo))
                    // sessionStorage.setItem('configData',JSON.stringify(res.data.configurationVO))
                    if (res.data.giftCardInfo.status == 1) {
                        this.$router.push({ path: '/welcome-home', query: { sn: this.sn } })
                    }
                    if (res.data.giftCardInfo.status == 0) {
                        this.$router.push({ path: '/password', query: { sn: this.sn } })
                    }
                    if (res.data.giftCardInfo.status == 2) {
                        this.$router.push({ path: '/result', query: { sn: this.sn, type: res.data.giftCardInfo.status } })
                    }
                    if (res.data.giftCardInfo.status == 3) {
                        this.$router.push({ path: '/result', query: { sn: this.sn, type: res.data.giftCardInfo.status } })
                    }
                    if (res.data.giftCardInfo.status == 4) {
                        this.$router.push({ path: '/result', query: { sn: this.sn, type: res.data.giftCardInfo.status } })
                    }
                } else {
                    this.$router.push({ path: '/result', query: { sn: this.sn } })
                }
            }, params)
        },
        getSnCode(params) {
            cnt.getSnCode(res => {
                if (res.code == 200) {
                    if (res.data.status == 1) {
                        this.sn = res.data.sn
                        this.getTravelRecord()
                    } else {
                        this.$router.push({ path: '/result', query: { sn: this.sn, type: 5 } })
                    }
                } else {
                    this.$router.push({ path: '/result', query: { sn: this.sn } })
                }
            }, params)
        },

        getConfig() {
            let activityId = ''
            if (this.$route.path == '/active') {
                activityId = this.$route.query.active
            } else {
                activityId = 8
            }
            let params = {
                activityId: activityId
            }
            cnt.getConfig(res => {
                console.log(123, 'home')
                if (res.code == 200) {
                    sessionStorage.setItem('configData', JSON.stringify(res.data.configurationVO))
                    this.getSnCode(params)
                }
            }, { authType: 1, activeId: activityId })
        }
    }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类</style>
